import { periodAPI } from 'api/period';
import { PeriodDto } from 'dto/period';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: PeriodDto) => void;
};

export function useFindOnePeriod(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_PERIOD, props.id],
    queryFn: () => periodAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
